<template>
    <form id="user_info_form" class="kt-form" @submit.prevent="update">
        <kt-form-section is_first>
            <kt-form-row>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="username">
                            {{ $t('label.username') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr" name="username" id="username"
                                         v-model="user.username"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="email">
                            {{ $t('label.email') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr" name="email" id="email" v-model="user.email"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="email">
                            {{ $t('label.user_level') }}
                        </kt-form-label>
                        <kt-form-select size="3" id="user_level" class="form-control" name="user_level"    v-model="user.user_level">
                            <option
                                value=""
                            >
                                {{ $t('selectpicker.nothing_selected') }}
                            </option>
                            <option value="1"
                            >
                                {{ $t('customers_club.l1') }}
                            </option>
                            <option
                                value="2"
                            >
                                {{ $t('customers_club.l2') }}
                            </option>
                            <option
                                value="3"
                            >
                                {{ $t('customers_club.l3') }}
                            </option>
                        </kt-form-select>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="first_name">
                            {{ $t('label.first_name') }}
                        </kt-form-label>
                        <kt-form-control name="first_name" id="first_name" v-model="user.first_name"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="first_name_en">
                            {{ $t('label.first_name_en') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr" name="first_name_en" id="first_name_en"
                                         v-model="user.first_name_en"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="last_name">
                            {{ $t('label.last_name') }}
                        </kt-form-label>
                        <kt-form-control name="last_name" id="last_name" v-model="user.last_name"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="last_name_en">
                            {{ $t('label.last_name_en') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr" name="last_name_en" id="last_name_en"
                                         v-model="user.last_name_en"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="father_name">
                            {{ $t('label.father_name') }}
                        </kt-form-label>
                        <kt-form-control name="father_name" id="father_name"
                                         v-model="user.father_name"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="father_name_en">
                            {{ $t('label.father_name_en') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr" name="father_name_en" id="father_name_en"
                                         v-model="user.father_name_en"></kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-form-row>

            <kt-form-row>
                <kt-col>
                    <kt-form-group>
                        <kt-form-label for="birth_date">
                            {{ $t('label.birth_date') }}
                        </kt-form-label>
                        <datePicker
                            format="YYYY-MM-DD HH:mm:ss"
                            display-format="dddd jDD jMMMM jYYYY"
                            input-class="form-control"
                            id="birth_date"
                            name="birth_date"
                            v-model="user.birth_date"
                            type="date"/>
                    </kt-form-group>
                </kt-col>
            </kt-form-row>
        </kt-form-section>

        <kt-form-section>
            <kt-form-row>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="phone">
                            {{ $t('label.phone') }}
                        </kt-form-label>

                        <kt-form-control
                            dir="ltr"
                            ref="phone"
                            name="phone"
                            id="phone"
                            v-model="user.phone"
                            :disabled="!($can('change-phone-number', 'user'))"
                        ></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="telephone">
                            {{ $t('label.telephone') }}
                        </kt-form-label>
                        <kt-form-control ref="telephone" dir="ltr" name="telephone" id="telephone"
                                         v-model="user.telephone"></kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-form-row>
        </kt-form-section>

        <kt-form-section>
            <kt-form-row>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="national_code">
                            {{ $t('label.national_code') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr" maxlength="10" name="national_code" id="national_code"
                                         v-model="user.national_code"></kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-form-row>
        </kt-form-section>
        <kt-form-section>
            <kt-form-row>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="birth_crtfct_number">
                            {{ $t('label.birth_crtfct_number') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr"  name="birth_crtfct_number" id="birth_crtfct_number"
                                         v-model="user.merchant.birth_crtfct_number"></kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-form-row>
        </kt-form-section>
        <kt-form-section>
            <kt-form-row>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="last_call_details">
                            {{ $t('label.last_call_details') }}
                        </kt-form-label>
                        <kt-form-textarea v-model="user.last_call_details" dir="rtl"  name="last_call_details" id="last_call_details"
                        >asaas</kt-form-textarea>
                    </kt-form-group>
                </kt-col>
            </kt-form-row>
        </kt-form-section>
        <kt-form-section v-if="user.merchant && user.merchant.addresses && user.merchant.addresses.length">
            <kt-form-row>
                <kt-col xs="12">
                    <kt-form-label for="address">
                        {{ $t('label.address') }}
                    </kt-form-label>
                </kt-col>

                <kt-col
                    v-for="(addr) in user.merchant.addresses"
                    :key="addr.id"
                    xs="12"
                    class="mb-3"
                >
                    <div class="border rounded p-3">
                        <p><strong>{{ $t('label.address') }}:</strong> {{ addr.address }}</p>
                        <p><strong>{{ $t('label.postal_code') }}:</strong> {{ addr.postal_code }}</p>
                    </div>
                </kt-col>
            </kt-form-row>
        </kt-form-section>
        <kt-form-section>
            <kt-row class="mb-3 pl-3">
                <kt-col lg="12" md="12" xs="12">
                    <div class="custom-control custom-switch">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="club_status"
                            name="club_status"
                            v-model="user.club_status"
                        >
                        <label class="custom-control-label" for="club_status">
                            {{ $t('label.club_status') }}
                        </label>
                    </div>
                </kt-col>
            </kt-row>
            <kt-row>
                <kt-col lg="12" md="12" xs="12">
                    <div class="text-black" :class="getShahkarInquiryStatusClass()"> {{ $t('label.shahkar_inquiry_status') }} : {{shahkarInquiryStatusStr.get(user.shahkar_inquiry)}}</div>
                </kt-col>
            </kt-row>
        </kt-form-section>

        <kt-form-action class="mt-4">
            <kt-row>
                <kt-col v-if="user.shahkar_inquiry == shahkarInquiryStatus.PENDING" lg="4" md="4" xs="12">
                    <button @click="shahkarInquiry" class="btn btn-md btn-info btn-wide" type="button"
                            id="shahkar-inquiry"
                            style="font-size: x-small">
                        {{ $t('label.shahkar_inquiry') }}
                    </button>
                </kt-col>
                <kt-col  lg="4" md="4" xs="12">
                    <button @click="userInfoInquiry" class="btn btn-md btn-info btn-wide" type="button"
                            id="user-info-inquiry"
                            style="font-size: x-small">
                        {{ $t('label.user_info_inquiry') }}
                    </button>
                </kt-col>
                <kt-col v-show="user.user_info_inquiry"  lg="4" md="4" xs="12">
                    <button class="btn btn-md btn-info btn-wide" type="button"
                            id="user_info_inquiry_detail" style="font-size: x-small"
                            data-toggle="modal"
                            data-target="#user-info-modal">
                        {{ $t('label.user_info_inquiry_detail') }}
                    </button>
                </kt-col>
            </kt-row>
        </kt-form-action>
        <kt-form-action class="mt-4">
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                        {{ $t('btn.submit_changes') }}
                    </button>
                </kt-col>
            </kt-row>
        </kt-form-action>
        <div v-if="user.user_info_inquiry" id="user-info-modal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">
                <!-- Modal content-->
                <div class="modal-content" id="user-info-modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{ $t('label.user_info_inquiry_detail') }}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <kt-row>
                            <div class="col-12" v-for="(request_data, index) in user.user_info_inquiry.request_data">
                                <kt-row>
                                <kt-col xs="4" sm="4" class="modal-field">
                                    <strong v-if="index === 'nationalCode'">{{ $t('label.national_code') }}</strong>
                                    <strong v-else-if="index === 'birthDate'" >{{ $t('label.birth_date') }}</strong>
                                    <strong v-else >{{ index }}</strong>
                                </kt-col>
                                <kt-col xs="8" sm="8" class="modal-field">
                                    <p>{{ request_data }}</p>
                                </kt-col>
                                </kt-row>
                            </div>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('label.first_name') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.first_name }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('label.last_name') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.last_name }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('label.father_name') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.father_name }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('label.birth_crtfct_number') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.birth_crtfct_number }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('label.birth_crtfct_serial') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.birth_crtfct_serial }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('label.birth_crtfct_seri') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.birth_crtfct_seri }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('label.gender') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p v-if="user.user_info_inquiry.gender">{{ $t('label.male') }}</p>
                                <p v-else-if="user.user_info_inquiry.gender == null"></p>
                                <p v-else>{{ $t('label.female') }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('label.is_alive_status') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p v-if="user.user_info_inquiry.is_alive">{{ $t('label.is_alive') }}</p>
                                <p v-else-if="user.user_info_inquiry.is_alive == null"></p>
                                <p v-else>{{ $t('label.is_not_alive') }}</p>
                            </kt-col>
                            <kt-col xs="4" sm="4" class="modal-field">
                                <strong>{{ $t('label.place_of_birth') }}</strong>
                            </kt-col>
                            <kt-col xs="8" sm="8" class="modal-field">
                                <p>{{ user.user_info_inquiry.place_of_birth }}</p>
                            </kt-col>
                        </kt-row>
                    </div>
                </div>
            </div>
        </div>


    </form>
</template>

<script>
    import {mapGetters} from 'vuex'
    import $ from 'jquery'
    import {KTApp} from '@/plugins/core/app'
    import {KTUtil} from '@/plugins/core/util'
    import {userService} from '@/common/api.service'
    import {shahkarInquiryStatus,shahkarInquiryStatusStr} from '@/constants/shahkarInquiryStatus'
    import Inputmask from "inputmask";
    import {i18n} from "@/plugins/i18n";
    import toastr from "toastr";

    export default {
        computed: {
            ...mapGetters('user', [
                'user', 'current_user'
            ]),
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-bottom-center",
                    preventDuplicates: false,
                    rtl: false
                }

                return toastr
            },
        },
        data() {
            return {
                months: [
                    {
                        title: i18n.t('month.farvardin'),
                        value: 1
                    },
                    {
                        title: i18n.t('month.ordibehesht'),
                        value: 2
                    },
                    {
                        title: i18n.t('month.khordad'),
                        value: 3
                    },
                    {
                        title: i18n.t('month.tir'),
                        value: 4
                    },
                    {
                        title: i18n.t('month.mordad'),
                        value: 5
                    },
                    {
                        title: i18n.t('month.shahrivar'),
                        value: 6
                    },
                    {
                        title: i18n.t('month.mehr'),
                        value: 7
                    },
                    {
                        title: i18n.t('month.aban'),
                        value: 8
                    },
                    {
                        title: i18n.t('month.azar'),
                        value: 9
                    },
                    {
                        title: i18n.t('month.day'),
                        value: 10
                    },
                    {
                        title: i18n.t('month.bahman'),
                        value: 11
                    },
                    {
                        title: i18n.t('month.esfand'),
                        value: 12
                    },
                ],
                shahkarInquiryStatus,
                shahkarInquiryStatusStr,
            }
        },
        mounted() {
            this.$nextTick(function () {
                this.initialSetup()
            })
        },
        methods: {
            initialSetup() {
                setTimeout(() => {
                    if (!this.$refs.selectPicker) {
                        return
                    }
                    let selects = $(this.$refs.selectPicker.$el).find('.kt-selectpicker')
                    $(selects).selectpicker({
                        size: 5
                    })

                    Inputmask('099-99999999').mask(this.$refs.telephone.$el)
                    Inputmask('0999-99999999').mask(this.$refs.phone.$el)
                }, 1000)

            },
            update(e) {
                let form = $(e.target)
                let btn = $('#submit_btn')

                form.validate({
                    ignore: ":hidden",

                    rules: {
                        username: {
                            required: true,
                            minlength: 5
                        },
                        first_name: {
                            required: true,
                        },
                        last_name: {
                            required: true,
                        },
                        first_name_en: {
                            required: true,
                        },
                        last_name_en: {
                            required: true,
                        },
                        father_name: {
                            required: true,
                        },
                        father_name_en: {
                            required: true,
                        },
                        national_code: {
                            required: true,
                        },
                        birth_date: {
                            required: true,
                        },
                        telephone: {
                            required: true
                        },
                        phone: {
                            required: true
                        },
                        email: {
                            required: true
                        },
                        birth_crtfct_number: {
                            required: true
                        },
                        // birth_crtfct_serial: {
                        //     required: true
                        // },
                        // birth_crtfct_series_letter: {
                        //     required: true
                        // },
                        // birth_crtfct_series_number: {
                        //     required: true
                        // },
                    },
                });

                if (!form.valid()) {
                    return
                }

                if (!this.validateSocialId(this.user.national_code)) {
                    form.validate().showErrors({
                        national_code: i18n.t('validation.invalid_national_code')
                    })
                    return;
                }

                let params = {
                    username: this.user.username,
                    first_name: this.user.first_name,
                    first_name_en: this.user.first_name_en,
                    email: this.user.email,
                    last_name: this.user.last_name,
                    last_name_en: this.user.last_name_en,
                    father_name: this.user.father_name,
                    father_name_en: this.user.father_name_en,
                    national_code: this.user.national_code,
                    birth_date: this.user.birth_date,
                    telephone: this.user.telephone,
                    phone: this.user.phone,
                    user_level: this.user.user_level,
                    birth_crtfct_number: this.user.merchant.birth_crtfct_number,
                    last_call_details: this.user.last_call_details,
                    club_status: this.user.club_status,
                    // birth_crtfct_serial: this.user.merchant.birth_crtfct_serial,
                    // birth_crtfct_series_letter: this.user.merchant.birth_crtfct_series_letter,
                    // birth_crtfct_series_number: this.user.merchant.birth_crtfct_series_number,
                }

                KTApp.progress(btn)

                userService.updateUser(this.user.id, params)
                    .then(response => {
                        this.$store.commit('user/success', response.data.data)
                        this.showMsg(form, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                            this.showMsg(form, 'danger', response.data.message)
                        }
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTUtil.scrollTop()
                        KTApp.unprogress(btn)
                    })
            },
            getYear() {
                return new Date().getFullYear() - 721
            },
            validateSocialId(social_id) {
                var L = social_id.length;

                if (L < 8 || parseInt(social_id, 10) == 0) return false;
                social_id = ('0000' + social_id).substr(L + 4 - 10);
                if (parseInt(social_id.substr(3, 6), 10) == 0) return false;
                var c = parseInt(social_id.substr(9, 1), 10);
                var s = 0;
                for (var i = 0; i < 9; i++)
                    s += parseInt(social_id.substr(i, 1), 10) * (10 - i);
                s = s % 11;
                return (s < 2 && c == s) || (s >= 2 && c == (11 - s));
            },
            shahkarInquiry(e) {
                let form = $('#user_info_form')
                let btn = $('#shahkar-inquiry')

                KTApp.progress(btn)

                let params = {
                    user_id : this.user.id
                }
                userService.shahkarInquiry(params).then(response => {
                    if (response.data.data == true) {
                        this.user.shahkar_inquiry = shahkarInquiryStatus.IS_MATCHED
                        return this.showMsg(form, 'success', response.data.message)
                    }
                    this.user.shahkar_inquiry = shahkarInquiryStatus.IS_NOT_MATCHED
                    return    this.showMsg(form, 'danger', response.data.message)
                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message)
                }).finally(() => {
                    KTUtil.scrollTop()
                    KTApp.unprogress(btn)
                })
            },
            getShahkarInquiryStatusClass(){
                let status = this.user.shahkar_inquiry
                if (status == shahkarInquiryStatus.PENDING)
                    return  'badge badge-warning';
                if (status == shahkarInquiryStatus.IS_MATCHED)
                    return  'badge badge-success';
                if (status == shahkarInquiryStatus.IS_NOT_MATCHED)
                    return  'badge badge-danger';
            },
            userInfoInquiry(){
                let btn = $('#user-info-inquiry')

                KTApp.progress(btn)

                userService.userInfoInquiry(this.user.id).then(response => {
                    if (response.data.data) {
                        this.user.user_info_inquiry = response.data.data
                        setTimeout(() => {
                            const button = document.getElementById('user_info_inquiry_detail');
                            button.click()
                        }, 1000);
                        return this.toastr.success(response.data.message)
                    }
                    return this.toastr.error(response.data.message)
                }).catch(({response}) => {
                    return this.toastr.error(response.data.message)
                }).finally(() => {
                    KTApp.unprogress(btn)
                })
            },
        },
    }
</script>

<style scoped>
.modal.fade .modal-dialog {
    transition: transform 0.3s ease-out;
    transform: translate(0, 50px);
}

.modal.show .modal-dialog {
    transform: translate(0, 0);
}

.modal-content {
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    background-color: #ffffff;
}

.modal-header {
    background-color: #1dc9b7;
    color: white!important;
    border-bottom: none;
    padding: 15px 25px;
    border-radius: 10px 10px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-header h4 {
    margin: 0;
    color: white!important;
    font-size: 1.5rem;
    text-align: center;
    flex-grow: 1;
}

.modal-header .close {
    color: white;
    font-size: 1.5rem;
    opacity: 1;
    background: transparent;
    border: none;
    cursor: pointer;
}

.modal-body {
    padding: 15px;
    font-size: 1rem;
    line-height: 1.6;
    color: #555;
}

.modal-body strong {
    font-weight: 600;
    color: #333;
}

.modal-body p {
    margin: 5px 0;
}

.modal-field {
    margin-bottom: 20px;
}

.kt-row {
    display: flex;
    flex-wrap: wrap;
}

.kt-col {
    margin-bottom: 15px;
}

.kt-col strong {
    color: #333;
}

.kt-col p {
    margin: 0;
    color: #555;
}

@media (max-width: 767px) {
    .modal-content {
        padding: 10px;
    }

    .modal-header h4 {
        font-size: 1.2rem;
    }

    .modal-body {
        padding: 10px;
    }
}
</style>


